module.exports = __webpack_public_path__ + "static/media/logo_vivo.ff57d602.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/App/img/logo_vivo.png
// module id = 198
// module chunks = 0